import React from 'react'
import { Step } from '../pages/ReviewFormPage'
import styles from '../styles/Reviews.module.scss'
import cn from 'classnames'
import { useMutation } from '@apollo/client'
import { INSTANT_REVIEW_PHONE_MUTATION } from '../apollo/mutation/instant_review_phone'
import parsePhoneNumber from 'libphonenumber-js'
import {ErrorMessage, Field, Form, Formik, FormikErrors, FormikValues} from 'formik'

interface ThankYouUnHappyProps {
  reviewId?: number
  firstName?: string

  setStep: (step: Step) => void
  onUpdateFormValues: (name: string, value: string) => void
}

export const ThankYouUnHappyStep: React.FC<ThankYouUnHappyProps> = ({ reviewId, setStep, onUpdateFormValues, firstName }) => {
  const [instantReviewPhone, { loading: instantReviewPhoneLoading }] = useMutation(INSTANT_REVIEW_PHONE_MUTATION)

  const validatePhoneForm = (values: FormikValues) => {
    const errors: FormikErrors<any> = {}
    const phoneNumber = parsePhoneNumber(values.phone, 'AU')

    if (!phoneNumber || (!phoneNumber.isValid() && phoneNumber.country !== 'AU')) {
      errors.phone = 'Phone is not valid'
    }

    return errors
  }

  const onSubmit = async (values: FormikValues) => {
    const hasError = validatePhoneForm(values)

    if (hasError?.length) {
      return
    }

    await instantReviewPhone({
      variables: {
        input: {
          id: reviewId,
          phone: values.phone,
          firstName: values.firstName,
        }
      }}
    ).then((data) => {
      setStep('in-touch-shortly')
      return data
    }).catch((e) => {
      console.log('save instant review error', e)
    })
  }

  const getIsBtnDisabled = (formik: any) => {
    return !formik.values.phone || !formik.values.firstName || instantReviewPhoneLoading
  }

  return (
    <div className={styles.thank_you}>
      <img src="/unhappy_people.svg" alt="Unhappy people"/>

      <p className={styles.thank_you_text}>
        We are really sorry that <br/>
        we made you feel that way.
      </p>

      <p className={styles.thank_you_text}>
        If you would like us to contact you <br/>
        please provide your name <br/>
        and phone number below.
      </p>

      <Formik
        initialValues={{
          phone: '',
          firstName,
        }}
        validate={validatePhoneForm}
        onSubmit={(values) => onSubmit(values)}
      >
        {
          props => (
            <Form>
              <div className={cn(styles.custom_input, props.errors.firstName ? styles.error : '')}>
                <Field
                  name="firstName"
                  required={true}
                >
                  {
                    // @ts-ignore
                    ({ field }) => {
                      const value = props.values.firstName
                      return (
                        <input type="text"
                          {...field}
                          placeholder={field.value ? '' : "Name"}
                          onChange={props.handleChange}
                          value={value}
                          onBlur={() => {
                            if (!value?.length) {
                              props.setFieldError('firstName', 'Name required')
                            }
                            onUpdateFormValues('firstName', value || '')
                         }}
                         className='data-hj-allow'
                        />
                      )
                    }
                  }
                </Field>
              </div>

              <div className={styles.phone_container}>
                <div className={cn(styles.custom_input, props.errors.phone ? styles.error : '')}>
                  <Field
                    name="phone"
                  >
                    {
                      // @ts-ignore
                      ({ field }) => {
                        const value = props.values.phone
                        return (
                          <input type="text"
                            {...field}
                            placeholder={field.value ? '' : "Phone number"}
                            onChange={(e) => {
                              const corrected = e.target.value.replace(/([^+0-9]+)/gi, '');
                              props.setFieldValue('phone', corrected)
                            }}
                            onBlur={(e) => {
                              const phoneNumber = parsePhoneNumber(e.target.value, 'AU')

                              if (!phoneNumber || !phoneNumber?.isValid() || phoneNumber?.country !== 'AU') {
                                props.setFieldError('phone', 'Phone is not valid')
                              }
                              onUpdateFormValues('phone', e.target.value)
                           }}
                           value={value}
                           className='data-hj-allow'
                          />
                        )
                      }
                    }
                  </Field>
                  <ErrorMessage name="phone" />
                </div>
              </div>

              <button className={styles.submit} type='submit' disabled={getIsBtnDisabled(props)}>
                Yes, contact me
              </button>

              <button
                onClick={() => {
                  setStep('not-contact-me')
                }}
                className={cn(styles.thank_you_link, styles.thank_you_link_margin)}
              >
                No, don’t contact me
              </button>
            </Form>
          )
        }
      </Formik>
    </div>
  )
}